import request from "../../../utils/request";

export const getFinanceReceiptList = '/finance/receipt/';

export function importFinanceReceipt(file: File) {
    const formData = new FormData()
    formData.append('file', file)
    return request.request({
        url: '/finance/receipt/import',
        method: 'post',
        data: formData
    })
}

export function getFinanceReceiptDetail(id: number) {
    return request.request({
        url: '/finance/receipt/detail',
        method: "get",
        params: {id: id}
    })
}

export function manualSettlement(id: number) {
    return request.request({
        url: '/finance/receipt/manualSettlement',
        method: "get",
        params: {receiptId: id}
    })
}

export function deleteReceipt(id: number) {
    return request.request({
        url: '/finance/receipt/',
        method: "delete",
        params: {receiptId: id}
    })

}
